// Shared utility function for parsing release notes body content
export interface ReleaseNotesCategories {
  [category: string]: string[];
}

export function parseBody(body: string | null | undefined): ReleaseNotesCategories {
  if (!body) return {};

  const lines = body.split('\n');
  const categories: ReleaseNotesCategories = {};
  let current: string | null = null;

  lines.forEach(line => {
    const cat = line.match(/^###\s+(.*)/);
    if (cat) {
      current = cat[1];
      categories[current] = [];
    } else if (current && (line.trim().startsWith('-') || line.trim().startsWith('*'))) {
      categories[current].push(line.replace(/^\s*[-*]\s*/, ''));
    }
  });

  return categories;
}
